<template>
  <div class="box">
    <div class="title" style="padding-top: 17px;margin-bottom: 25px;">成果</div>
    <div class="ring">
<!--      <div id="myChart" :style="{width: '50%', height: '120px'}"></div>-->
      <div class="left"><span>{{countImportResult}}</span>项核心成果</div>
      <div class="right"><span>{{countResult}}</span>项成果</div>
    </div>
    <div class="banner-image" id="typeChart" style="width:100%;height: 476px;"></div>
  </div>
</template>

<script>
export default {
  name: 'result',
  data () {
    return {
      countResult: '',
      countImportResult: ''
    }
  },
  mounted () {
    this.fetchData();
    this.drawChart();
  },
  methods: {
    fetchData () {
      let _self = this;
      _self.post('/dataapi/open/nqi/fruit/countFruit').then(res => {
        _self.post('/dataapi/open/nqi/fruit/countImportFruit').then(importCount => {
          _self.countImportResult = String(importCount.result).replace(/(\d)(?=(\d{3})+$)/g, '$1,');
          _self.countResult = String(res.result).replace(/(\d)(?=(\d{3})+$)/g, '$1,');
          // let value = '';
          // value = res.result;
          // 基于准备好的dom，初始化echarts实例
          // let myChart = echarts.init(document.getElementById('myChart'))
          // 绘制图表
          // myChart.setOption({
          //   color: ['#00FFF4', '#0378DB'],
          //   tooltip: {
          //     trigger: 'item'
          //   },
          //   series: [
          //     {
          //       type: 'pie',
          //       center: ['50%', '50%'],
          //       radius: ['45%', '80%'],
          //       label: {
          //         show: false
          //       },
          //       data: [
          //         {
          //           value: value,
          //           name: '成果'
          //         },
          //         {
          //           value: importCount.result,
          //           name: '核心成果'
          //         }
          //       ]
          //     }
          //   ]
          // });
        })
      });
    },
    drawChart () {
      const _self = this;
      _self.fetch('/dataapi/open/nqi/fruit/getImportFruitCountByStyle').then(res => {
        _self.typeList = res.result.sort((a, b) => { return b.rs - a.rs; });
        // _self.typeList = _self.typeList.splice(0, 10);
        _self.chart = echarts.init(document.getElementById('typeChart'));
        let yAxis = [];
        let value = [];
        for (let item of _self.typeList) {
          yAxis.push(item.fruit_style);
          value.push({
            itemStyle: {
              color: new echarts.graphic.LinearGradient(1, 1, 0, 0, [{
                offset: 0,
                color: '#00CCD2' // 0% 处的颜色
              }, {
                offset: 0.6,
                color: '#0F87FA' // 100% 处的颜色
              }], false),
              barBorderRadius: [30, 30, 30, 30]
            },
            value: item.rs
          });
        }
        _self.chart.setOption({
          title: {
            left: 'center'
          },
          tooltip: {
            trigger: 'item'
          },
          xAxis: {
            type: 'log',
            minorSplitLine: {
              show: false
            },
            splitLine: {show: false},
            axisLabel: {textStyle: {color: '#e2e9ff'}}
          },
          yAxis: {
            type: 'category',
            splitLine: {show: false},
            axisLabel: {'interval': 0, rotate: 0, textStyle: {color: '#e2e9ff'}},
            data: yAxis,
            inverse: true
          },
          grid: {
            top: 10,
            bottom: 80,
            left: 220,
            right: 30
          },
          series: [
            {
              name: '成果形式统计',
              type: 'bar',
              label: {
                show: true
              },
              data: value,
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(24,31,68,1)',
                borderRadius: 30
              }
            }
          ]
        });
      });
    }
  }
}
</script>

<style scoped>
.box{
  background-image: url('../assets/images/contentBg.png');
  background-size: 100% 100%;
  width: 100%;
  height: 500px;
}
.title{
  width: 36px;
  height: 25px;
  font-size: 18px;
  font-weight: 600;
  color: #00FFF4;
  line-height: 25px;
  margin: 0 auto;
}
#myChart{
  margin-left: 39px;
}
.ring{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  color: #00FFF4;
  font-size: 16px;
}
.ring span{
  font-size: 20px;
  font-weight: 600;
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/result.vue